<script>
export default {
    name: "Jozzy",
    created() {
        localStorage.setItem('ref', 'jozzy')
    },
    methods: {
        goToSignup() {
            this.$router.push({ path: '/signup', query: this.$route.query })
        },
    }
}
</script>

<template>
    <section class="media">
        <div class="media-wrapper">
            <div class="about-media-container">
                <div class="media-text-container">
                    <div class="media-title">Jozzy {{ __('играет с Cloud Mods, попробуй и ты!') }}</div>
                    <div class="media-desc">{{ __('Мы с нуля разработали сначала приложение, а теперь регулярно выпускаем новые эксклюзивные модификации, как платные, так и бесплатные.')}}</div>
                </div>
                <div class="media-buttons-container">
                    <a href="/CloudModsSetup.exe" download class="button">
                        <svg class="download" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0004 16.89C11.8404 16.89 11.6904 16.865 11.5504 16.815C11.4104 16.765 11.2804 16.68 11.1604 16.56L6.84039 12.24C6.60039 12 6.48539 11.72 6.49539 11.4C6.50539 11.08 6.62039 10.8 6.84039 10.56C7.08039 10.32 7.36539 10.195 7.69539 10.185C8.02539 10.175 8.31039 10.29 8.55039 10.53L10.8004 12.78V4.2C10.8004 3.86 10.9154 3.575 11.1454 3.345C11.3754 3.115 11.6604 3 12.0004 3C12.3404 3 12.6254 3.115 12.8554 3.345C13.0854 3.575 13.2004 3.86 13.2004 4.2V12.78L15.4504 10.53C15.6904 10.29 15.9754 10.175 16.3054 10.185C16.6354 10.195 16.9204 10.32 17.1604 10.56C17.3804 10.8 17.4954 11.08 17.5054 11.4C17.5154 11.72 17.4004 12 17.1604 12.24L12.8404 16.56C12.7204 16.68 12.5904 16.765 12.4504 16.815C12.3104 16.865 12.1604 16.89 12.0004 16.89ZM4.80039 22.2C4.14039 22.2 3.57539 21.965 3.10539 21.495C2.63539 21.025 2.40039 20.46 2.40039 19.8V17.4C2.40039 17.06 2.51539 16.775 2.74539 16.545C2.97539 16.315 3.26039 16.2 3.60039 16.2C3.94039 16.2 4.22539 16.315 4.45539 16.545C4.68539 16.775 4.80039 17.06 4.80039 17.4V19.8H19.2004V17.4C19.2004 17.06 19.3154 16.775 19.5454 16.545C19.7754 16.315 20.0604 16.2 20.4004 16.2C20.7404 16.2 21.0254 16.315 21.2554 16.545C21.4854 16.775 21.6004 17.06 21.6004 17.4V19.8C21.6004 20.46 21.3654 21.025 20.8954 21.495C20.4254 21.965 19.8604 22.2 19.2004 22.2H4.80039Z" fill="white"/>
                        </svg>
                        {{ __('Скачать бесплатно') }}
                    </a>
                    <div class="button reg" @click="goToSignup">
                        {{ __('Создать аккаунт') }}
                    </div>
                </div>
            </div>
            <img src="@/assets/images/media_url/jozzy.png" class="media-image">
        </div>
    </section>
</template>

<style scoped>
.media {
    width: 100%;
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    background-repeat: no-repeat;
    background-position: center;
}

.media-wrapper {
    display: flex;
    align-items: center;
}

.about-media-container {
    display: flex;
    flex-direction: column;
}

.media-text-container {
    display: flex;
    flex-direction: column;
}

.media-buttons-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
}

.media-title {
    color: var(--text-primary);
    font-weight: 700;
}

.media-desc {
    color: var(--text-secondary);
    font-weight: 500;
}

.button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--color-main);
    transition: 0.25s ease;
}

.button.reg {
    background: none;
    border: 1px solid #41414C;
    transition: 0.25s ease;
}

.button:hover {
    cursor: pointer;
}

.button:hover{
    background: #6143CE;
}

.button.reg:hover {
    background: #5E5E6D;
}

.media-image {
    margin-top: 10%;
}

@media (min-width: 320px) {
    .media {
        height: 168.75vw;
        background-size: contain;
        background-image: url("@/assets/images/media_url/media_320.png");
    }

    .media-wrapper {
        width: 90vw;
        align-content: space-between;
    }

    .about-media-container {
        gap: 6.25vw;
    }

    .media-text-container {
        gap: 6.25vw;
    }

    .media-buttons-container {
        gap: 5vw;
    }

    .media-title {
        width: 70vw;
        line-height: 112%;
        font-size: 9vw;
    }

    .media-desc {
        width: 70vw;
        font-size: 5vw;
        line-height: 137%;
    }

    .button {
        padding: 3.75vw 6.25vw;
        gap: 2.5vw;
        border-radius: 3.75vw;
    }

    .download {
        height: 6.25vw;
        width: 6.25vw;
    }

    .media-image {
        margin-right: 60%;
        height: 50%;
        display: none;
    }
}

@media (min-width: 464px) {
    .media {
        height: 470px;
        background-size: auto;
        background-image: url("@/assets/images/media_url/media_464.png");
    }

    .media-wrapper {
        width: 464px;
        align-content: space-between;
    }

    .about-media-container {
        gap: 20px;
    }

    .media-text-container {
        gap: 20px;
    }

    .media-buttons-container {
        gap: 16px;
    }

    .media-title {
        width: 400px;
        line-height: 112%;
        font-size: 40px;
    }

    .media-desc {
        width: 400px;
        font-size: 16px;
        line-height: 137%;
    }

    .button {
        padding: 12px 20px;
        gap: 8px;
        border-radius: 12px;
    }

    .download {
        height: 20px;
        width: 20px;
    }

    .media-image {
        margin-right: 60%;
        height: 50%;
        display: block;
    }
}

@media (min-width: 744px) {
    .media {
        height: 654px;
        background-image: url("@/assets/images/media_url/media_744.png");
    }

    .media-wrapper {
        width: 744px;
        align-content: space-between;
    }

    .about-media-container {
        gap: 28px;
    }

    .media-text-container {
        gap: 24px;
    }

    .media-buttons-container {
        gap: 16px;
    }

    .media-title {
        width: 672px;
        line-height: 112%;
        font-size: 48px;
    }

    .media-desc {
        width: 672px;
        font-size: 22px;
        line-height: 137%;
    }

    .button {
        padding: 12px 20px;
        gap: 8px;
        border-radius: 12px;
    }

    .download {
        height: 20px;
        width: 20px;
    }

    .media-image {
        display: none;
    }
}

@media (min-width: 984px) {
    .media {
        height: 790px;
        background-image: url("@/assets/images/media_url/media_1248.png");
    }

    .media-wrapper {
        width: 984px;
        align-content: space-between;
    }

    .about-media-container {
        gap: 28px;
    }

    .media-text-container {
        gap: 24px;
    }

    .media-buttons-container {
        gap: 16px;
    }

    .media-title {
        width: 672px;
        line-height: 112%;
        font-size: 48px;
    }

    .media-desc {
        width: 672px;
        font-size: 22px;
        line-height: 137%;
    }

    .button {
        padding: 12px 20px;
        gap: 8px;
        border-radius: 12px;
    }

    .download {
        height: 20px;
        width: 20px;
    }

    .media-image {
        display: block;
        height: 100%;
    }
}

@media (min-width: 1248px) {
    .media {
        height: 764px;
        background-image: url("@/assets/images/media_url/media_1248.png");
    }

    .media-wrapper {
        width: 1248px;
        align-content: space-between;
    }

    .about-media-container {
        gap: 28px;
    }

    .media-text-container {
        gap: 24px;
    }

    .media-buttons-container {
        gap: 16px;
    }

    .media-title {
        width: 672px;
        line-height: 112%;
        font-size: 48px;
    }

    .media-desc {
        width: 672px;
        font-size: 22px;
        line-height: 137%;
    }

    .button {
        padding: 12px 20px;
        gap: 8px;
        border-radius: 12px;
    }

    .download {
        height: 20px;
        width: 20px;
    }

    media-image {
        height: 100%;
    }
}

</style>